import { BrowserRouter, Route, Routes } from "react-router-dom";

function SettingsRouter(){
    return(
       <h1>Welcome to settings</h1>
    )
}

export {SettingsRouter}